import React from "react";
import PricingHero from "../components/PricingHero";
import PricingPlans from "../components/PricingPlans";
import Footer from "../components/Footer";
import FAQ from "../components/FAQ";
import SEO from "../components/SEO";
import ReadyToSeeDifference from "../components/ReadyToSeeDifference";

const Pricing = () => {
  return (
    <div className="bg-[#fdfdfd]">
      <SEO
        title="AI Smile Simulation Pricing Plans from $99/mo"
        description="SmileReveal™ AI smile simulation pricing starts at $99/month. Plans for solo practices, growing clinics, and DSOs. Unlimited simulations, website lead capture, analytics. Free trial, no contracts."
        canonical="https://smilereveal.io/pricing"
      />
      <div
        className="relative"
        style={{
          backgroundImage: "url('/svgs/pricing_bg.svg')",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        {/* Gradient fade at bottom */}
        <div className="pointer-events-none absolute bottom-0 left-0 w-full h-32 bg-gradient-to-b from-transparent to-white backdrop-blur-0 z-40"></div>

        <PricingHero />
      </div>
      <main>
        <PricingPlans />
        <FAQ />
        <ReadyToSeeDifference />
      </main>

      <Footer />
    </div>
  );
};

export default Pricing;
